import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { manageCubesQueryKeys } from "./queryKeys";

export function useExportList(cubeId: string | undefined) {
  const apiClient = useApi();

  return useQuery({
    queryKey: manageCubesQueryKeys.exports(cubeId ?? ""),
    meta: {
      errorMessage: "Failed to fetch exports"
    },
    queryFn: async () => {
      const response = await apiClient.POST("/v2/forecast/exports/list", {
        body: { cube_id: cubeId! }
      });

      return response.data?.result ?? { exports: [] };
    },
    enabled: !!cubeId
  });
}
